import { render, staticRenderFns } from "./KanbanBoardSlot.vue?vue&type=template&id=2d32e2d6&scoped=true"
import script from "./KanbanBoardSlot.vue?vue&type=script&lang=js"
export * from "./KanbanBoardSlot.vue?vue&type=script&lang=js"
import style0 from "./KanbanBoardSlot.vue?vue&type=style&index=0&id=2d32e2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d32e2d6",
  null
  
)

export default component.exports